import React            from 'react';
import PropTypes        from 'prop-types';
import { Link }         from 'react-router-dom';
// import classNames       from 'classnames';

// import useMessage      from './useHeader';
import Button           from '../../../../components/Button';

import MainBG           from '../../../../../assets/images/main.jpg'

import config           from '../../../../../../etc/config.json';

import styles           from './MainBlock.styl';

function MainBlock() {
    // const {  } = props;

    // const {} = useMessage();

    return  (
        <section
            className={styles.MainBlock}
            style     = {{
                backgroundImage    : `url(${MainBG})`,
                backgroundPosition : 'right',
                backgroundSize     : 'contain',
                backgroundRepeat   : 'no-repeat'
            }}
        >
            <div className={styles.blockWrapper}>
                <div className={styles.leftBlock}>
                    <h1 className={styles.title}>
                    Your Advanced UA <span className={styles.mainColor}>Automation</span>
                    </h1>
                    <h3 className={styles.description}>
                    Automation becomes clear. Roimax is the best software platform for running UA Automation.
                    </h3>
                    <div className={styles.buttons} >
                        <Link
                            to        = '/create-account'
                            className = {styles.buttonLink}
                        >
                            <Button
                                className = {styles.trialButton}
                                color     = 'filled'
                            >
                                Start free trial
                            </Button>
                        </Link>
                        <a
                            href      = {config.loginUrl}
                            className = {styles.loginButton}
                            target    = '_blank'
                            rel       = 'noreferrer'
                        >
                        Login
                        </a>
                    </div>
                </div>
                <div className={styles.rightBlock}>
                    <img src={MainBG} className={styles.mainBg} />
                </div>
            </div>
        </section>
    );
}

MainBlock.propTypes = {
    className : PropTypes.string
};

MainBlock.defaultProps = {
    className : ''
};

export default MainBlock;
